import { Component, Vue, Prop } from 'vue-property-decorator'
import { MasterlinkMenuTreeNode } from '@/service-proxies/app-v2/system.service-proxies'

@Component
export default class MenuTable extends Vue {
  @Prop({ default: () => [] }) data: MasterlinkMenuTreeNode[]
  @Prop({ default: false }) loading: boolean

  get columns() {
    return [
      {
        title: this.$t('page_authority_action'),
        dataIndex: 'action',
        key: 'action',
        width: 160,
        customRender: (text, record) => {
          return (
            <a
              href="javascript:;"
              onclick={e => {
                this.$emit('rowClick', record)
              }}
            >
              {this.$t('edit')}
            </a>
          )
        },
      },
      {
        title: this.$t('page_menu_icon'),
        dataIndex: 'data.source',
        key: 'data.source',
        customRender: v => {
          return !!v ? <a-icon type={v} /> : ''
        },
        width: 160,
        ellipsis: true,
        align: 'center',
      },
      {
        title: this.$t('page_menu_sort'),
        dataIndex: 'data.sort',
        key: 'data.sort',
        width: 160,
        ellipsis: true,
        align: 'center',
      },
      {
        title: this.$t('page_menu_desc'),
        dataIndex: 'data.name',
        key: 'data.name',
        // width: 240,
        ellipsis: true,
        customRender: (_, record) => {
          return this.$t(record.data.code)
        },
      },
    ]
  }

  render() {
    const helper = arr => {
      return arr.map(item => {
        if (item.children.length > 0) {
          return {
            ...item,
            children: helper(item.children),
          }
        } else {
          const res = {
            ...item,
          }
          delete res.children
          return res
        }
      })
    }
    const { data, loading, columns } = this
    const normData = helper(data)
    return (
      <ml-table
        columns={columns}
        dataSource={normData}
        loading={loading}
        size="small"
        rowKey="id"
        pagination={false}
        canChangeColWidth={true}
      />
    )
  }
}
